module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_2.46312bd1.png";